import React from 'react'
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'
import RenderGate from '../RenderGate/renderGate'

class Carousel extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      images: this.props.images || []
    }
  }

  componentDidMount () {
    this.initCarousel()
  }

  initCarousel () {
    const swiper = new Swiper('.swiper-container', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      // If we need pagination
      pagination: {
        el: '.swiper-pagination'
      },
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      centeredSlides: true,
      slidesPerView: 1,
      spaceBetween: 0,
      setWrapperSize: true,
      breakpoints: {
        600: {
          slidesPerView: 2,
          spaceBetween: 30
        }
      }
    })
  }

  render () {
    return (
      <div className='project-carousel'>
        <div className='swiper-container'>
          <div className='swiper-wrapper'>
            <RenderGate shouldRender={this.state.images}>
              {this.state.images.map((image, idx) =>
                <div key={idx} className='swiper-slide'>
                  <img alt='project reference' src={image} />
                </div>
              )}
            </RenderGate>
          </div>
          <div className='swiper-pagination' />

          <div className='swiper-button swiper-button-prev' />
          <div className='swiper-button swiper-button-next' />
        </div>
      </div>
    )
  }
}

export default Carousel
